// removed by extract-text-webpack-plugin
module.exports = {"container":"_2cFbW5cNnWO80uj050ymYy","row":"_28bfUMe66TwW0kvOzwabVL","headerMainSection":"_1waEoqWQwdS3etV6LYAYNr","leftColumn":"hzWcyezZ5FNLgkN4ldbH","infoSection":"_2lCpjqp2Qvi2HwClrSz3pc"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OasisHeader.scss
// module id = 1060
// module chunks = 0